import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Button, Heading, HStack, Stack, Text } from "@chakra-ui/react";

export default function Opportunities() {
  const navigate = useNavigate();

  return (
		<>
			<Helmet>
				<title>LaborHack | Opportunities</title>
			</Helmet>
			<div className="flex flex-col gap-8 w-full bg-[#FEFEFE]">
				<Stack>
					<HStack
						borderBottom={"1px"}
						borderColor={"#E4E4E4"}
						py={4}
						textColor={"#212121"}
						mb={{
							base: 4,
							lg: 8,
						}}
					>
						<Heading
							as={"h2"}
							fontWeight={"normal"}
							fontSize={{
								base: "18px",
								lg: "20px",
							}}
						>
							Explore opportunities
						</Heading>
					</HStack>
					<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						{/* Community Opportunities Card */}
						<Stack
							spacing={4}
							className="border border-[#E4E4E4] p-6 flex-1 flex-col justify-between"
						>
							<Heading as="h3" size="md" fontWeight="medium" color="#0E212D">
								Community opportunities
							</Heading>
							<Text className="text-[#6E6E6E] text-[14px] lg:text-[16px] leading-relaxed">
								Jobs that have been posted by communities that you're a member
								of. These opportunities are tailored to your community
								affiliations.
							</Text>
							<Button
								onClick={() => navigate("/opportunities/communities")}
								colorScheme="prussianBlue"
								size="md"
								fontSize="16px"
							>
								View community jobs
							</Button>
						</Stack>
						{/* LaborHack Opportunities Card */}
						<Stack
							spacing={4}
							className="border border-[#E4E4E4] p-6 flex-1 flex-col justify-between"
						>
							<Heading as="h3" size="md" fontWeight="medium" color="#0E212D">
								LaborHack opportunities
							</Heading>
							<Text className="text-[#6E6E6E] text-[14px] lg:text-[16px] leading-relaxed">
								Jobs that are available to the wider LaborHack community.
								Discover broader opportunities across the platform.
							</Text>
							<Button
								colorScheme="brand"
								size="md"
								fontSize="16px"
								onClick={() => navigate("/opportunities/laborhack")}
							>
								View LaborHack jobs
							</Button>
						</Stack>
					</div>
				</Stack>
			</div>
		</>
	);
}
